import _ from "lodash";

export const BLEED_LINE = _.isUndefined(process.env.REACT_APP_BLEED_LINE) ? 3 : +process.env.REACT_APP_BLEED_LINE;
export const SAFETY_LINE = _.isUndefined(process.env.REACT_APP_SAFETY_LINE) ? 3 : +process.env.REACT_APP_SAFETY_LINE;
export const PARENT_SITE_ORIGIN = (process.env.REACT_APP_PARENT_SITE_ORIGIN || '').split(',').filter(o => !!o);
export const REPORT_URL = process.env.REACT_APP_REPORT_URL || 'http://localhost:5000/api/kdpl-preflight-service/reports';
export const SCROLL_STEP = 5;
export const SHOW_SHAPE_DIMENSIONS_INPUTS = process.env.REACT_APP_SHOW_SHAPE_SIZE_INPUTS === 'true' || false;
